import { z } from 'zod';

export const zodDeleteContractEndpointSchema = z.tuple([
  z.literal('contracts'),
  z.uuid(),
]);
